<nz-upload #uploader [nzShowButton]="canUpload$ | async" [nzAction]="uploadUrl"
    (nzChange)="uploadChange($event)" [nzFileList]="files$ | async" [nzBeforeUpload]="beforeUpload"
    [nzFileList]="files$ | async" [nzMultiple]="true" [nzShowUploadList]="nzShowUploadList$ | async"
    [nzAccept]="accept$ | async"
    (nzFileListChange)="fileListChange($event)" nzListType="picture-card" [nzDownload]="download">
    <i nz-icon nzType="plus"></i>
    <div class="ant-upload-text">{{'Common.Upload' | translate}}</div>
</nz-upload>
<div class="size-limit">{{'Common.AttachmentMax' | translate}} {{attachmentSize/1024/1024}}MB</div>
